import PropTypes from 'prop-types';

export default {
  handleClose: PropTypes.func,
  editOpened: PropTypes.bool,
  selectedRoute: PropTypes.object,
  classes: PropTypes.object,
  selectedPassenger: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
};



// WEBPACK FOOTER //
// ./src/containers/meals/mobile/mealsSelection/MealsSelectionDialogProps.js